/* istanbul ignore file */
export default
`<div ref="printRef">
    <div ref="masonryContainer" class="masonry-layout" :class="containerClasses" :style="containerStyles">
        <div class="header-content" :class="headerClasses" :style="headerStyles" ref="headerContent" v-if="settings.enableHeader">
            <div class="header-top-row">
                <div class="header-logo" v-if="settings.headerLogoImage">
                    <img :src="settings.headerLogoImage" :style="headerLogoStyles" :alt="settings.headerLogoAltText" :title="settings.headerLogoTitle"/>
                </div>
                <div class="header-text">
                    <component :is="{template: '<div>' + settings.header + '</div>', props:{user: {default: false}}}" :user="user" />
                </div>
                <div class="header-components">
                    <div v-if="positionsFiltered[0]" v-for="(component, index) in positionsFiltered[0].components" :key="component.cId">
                        <component 
                            v-bind="componentMappedProps[component.cId]" 
                            :is="component.cType" 
                            :cId="component.cId" 
                            :editor-enabled="editorEnabled"
                            v-if="displayedComponents[component.cId]" 
                            v-show="showedComponents[component.cId]" 
                            :unique-store-id="uniqueStoreId"
                            class="layout-component"
                            :ref="'ref__' + component.cId"
                        ></component>
                    </div>
                </div>
            </div>
            <p v-if="settings.headerMessage">{{settings.headerMessage}}</p>
        </div>
        <div :class="['masonry', columnClass, ratioClass]">
            <div :id="'column1_' + templateUniqueId" style="height: 100%;">
                <div v-if="positionsFiltered[1]" v-for="(component, index) in positionsFiltered[1].components" :key="component.cId">
                    <component 
                        v-bind="componentMappedProps[component.cId]"
                        :is="component.cType" :cId="component.cId"
                        v-if="displayedComponents[component.cId]"
                        v-show="showedComponents[component.cId]"
                        :editor-enabled="editorEnabled"
                        :unique-store-id="uniqueStoreId"
                        :style="columnSpecificComponentStyles[0]"
                        class="layout-component"
                        :ref="'ref__' + component.cId"
                    ></component>
                </div>
            </div>
            <div :id="'column2_' + templateUniqueId" style="height: 100%;">
                <div v-if="positionsFiltered[2]" v-for="(component, index) in positionsFiltered[2].components" :key="component.cId" class="">
                    <component 
                        v-bind="componentMappedProps[component.cId]"
                        :is="component.cType" :cId="component.cId" 
                        v-if="displayedComponents[component.cId]"
                        v-show="showedComponents[component.cId]"
                        :editor-enabled="editorEnabled"
                        :unique-store-id="uniqueStoreId"
                        :style="columnSpecificComponentStyles[1]"
                        class="layout-component masonry-item"
                        :ref="'ref__' + component.cId"
                    ></component>
                </div>
            </div>
        </div>
        <div class="footer-content" ref="footerContent" v-if="settings.enableFooter">
            <div v-if="positionsFiltered[3]" v-for="(component, index) in positionsFiltered[3].components" :key="component.cId">
                <component 
                    v-bind="componentMappedProps[component.cId]" 
                    :is="component.cType" 
                    :cId="component.cId" 
                    :editor-enabled="editorEnabled"
                    v-if="displayedComponents[component.cId]" 
                    v-show="showedComponents[component.cId]"
                    :unique-store-id="uniqueStoreId"
                    class="layout-component"
                    :ref="'ref__' + component.cId"
                ></component>
            </div>
        </div>
    </div>
</div>`;
